<script>
  import { page } from '$app/stores';

  export let user;
  export let mutualSuggestedFollow;
  export let suggestedFollow;

  let hasMutualSuggestedFollow = mutualSuggestedFollow && mutualSuggestedFollow.id;
  let hasSuggestedFollow = suggestedFollow && suggestedFollow !== '';
  let utmMedium = $page.url.searchParams.get('utm_medium');
  let name = $page.url.searchParams.get('name');

  let useScoutedOutreachOgImage = utmMedium === 'scouted-outreach';

  let title = `${user && user.name} | Benable invite`;
  let description = `50k+ on waitlist. Skip the line.`;
  let ogImage = user && user.og_invite_url;
  let ogImageWidth = 600;
  let ogImageHeight = 960;

  if (hasMutualSuggestedFollow || hasSuggestedFollow) {
    title = user && user.name ? `${user.name} is inviting you!` : 'Benable - for influencers & all';
    ogImageHeight = 750;
    ogImage = `${import.meta.env['VITE_API_URL']}/og/images/ig_dm/${utmMedium}.png`;
  }

  if (useScoutedOutreachOgImage) {
    if (name && name != '') {
      title = `${name} | You've been invited!`;
    } else {
      title = `You've been invited!`;
    }

    ogImageWidth = 600;
    ogImageHeight = 599;
  }

  if (user && user.invite_og_image_url) {
    ogImage = user.invite_og_image_url;
    ogImageWidth = undefined;
    ogImageHeight = undefined;
  }
</script>

<svelte:head>
  {#if user}
    <title>Shareable lists of things you recommend</title>
    <meta name="url" content="{import.meta.env['VITE_SITE_URL']}{user.profile_path}" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    {@html `<meta property="og:image" content="https://image-proxy.benable.com/x/plain/${ogImage}" />`}

    {#if ogImageWidth}
      <meta property="og:image:width" content={ogImageWidth} />
    {/if}
    {#if ogImageHeight}
      <meta property="og:image:height" content={ogImageHeight} />
    {/if}

    {@html `<meta property="twitter:image" content="${ogImage}" />`}
    <meta name="twitter:site" content="@Benable_HQ" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta property="og:type" content="website" />
    {@html `<meta property="og:video:url" content="${ogImage}" />`}
    <meta property="og:video:width" content={ogImageWidth} />
    <meta property="og:video:height" content={ogImageHeight} />
  {/if}
</svelte:head>
